import { render } from "./IntoxicationBar.vue?vue&type=template&id=204882fa&scoped=true&ts=true"
import script from "./IntoxicationBar.vue?vue&type=script&lang=ts"
export * from "./IntoxicationBar.vue?vue&type=script&lang=ts"

import "./IntoxicationBar.vue?vue&type=style&index=0&id=204882fa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204882fa"]])

export default __exports__